import {RumTimeMark, sendRumTimeMark} from '@logistics-frontend/modules/rum'
import {applyPolyfills} from '@logistics-frontend/polyfills'
import React, {StrictMode} from 'react'
import ReactDOM from 'react-dom'

import {App} from './app'

sendRumTimeMark(RumTimeMark.BEFORE_JS_FRAMEWORK_INIT)

applyPolyfills().then(() =>
  ReactDOM.render(<StrictMode children={<App />} />, document.getElementById('root'), () =>
    sendRumTimeMark(RumTimeMark.REACT_INITED),
  ),
)

sendRumTimeMark(RumTimeMark.JS_FRAMEWORK_INITED)
